export default __webpack_public_path__ + "static/img/12.f8dcf21.png";